// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"383":"bf35ec56","512":"0c0fca49","719":"bf35ec56","811":"bf35ec56","839":"bf35ec56","894":"bf35ec56"}[chunkId] + ".chunk.css";
};